module.exports = global.config = {
  colours: {
    //primary: '#2C89C6'
    primary: '#2697FE',
    success: '#00ad45'
  }
}

//global.primary = '#';